import type * as Types from '../base-types.graphql';

import { gql } from '@apollo/client';
import { ScFieldsFragmentDoc, ScWithMinMaxFieldsFragmentDoc } from './share-class.graphql';
import { ValidatorStatusFieldsFragmentDoc } from './validator-status.graphql';
export type GqlOsrSubscriberFieldsFragment = { createdAt: string, id: string, identityId: string, optionsSharesRegistrationId: string, paymentStatus: number, quantity: string, updatedAt: string, shareClass: { name: string, voteWeight: string, quantity?: string | null } };

export type GqlOssValidatorErrorFieldsFragment = { paymentStatus: { completed: boolean, hasError: boolean, severity: Types.GqlSeverity, error?: { sv: { short?: string | null, long?: string | null }, en: { short?: string | null, long?: string | null } } | null }, proxy: { completed: boolean, hasError: boolean, severity: Types.GqlSeverity, error?: { sv: { short?: string | null, long?: string | null }, en: { short?: string | null, long?: string | null } } | null } };

export const OsrSubscriberFieldsFragmentDoc = gql`
    fragment OsrSubscriberFields on OptionsSharesSubscriber {
  createdAt
  id
  identityId
  optionsSharesRegistrationId
  paymentStatus
  quantity
  shareClass {
    ...ScFields
  }
  updatedAt
}
    ${ScFieldsFragmentDoc}`;
export const OssValidatorErrorFieldsFragmentDoc = gql`
    fragment OssValidatorErrorFields on OssValidatorErrors {
  paymentStatus {
    ...ValidatorStatusFields
  }
  proxy {
    ...ValidatorStatusFields
  }
}
    ${ValidatorStatusFieldsFragmentDoc}`;